import Breadcrumb from "../components/Breadcrumb";
import CarListingDetailLayer from "../components/child/CarListingDetailLayer";

const CarListingDetail = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title='Car Listing Details' />

      <CarListingDetailLayer />
    </>
  );
};

export default CarListingDetail;

